import { gql } from '@apollo/client'
import {
  POST_ITEM_FIELDS,
  POST_ITEM_FIELDS_FORLIST,
  POST_ITEM_USER,
} from './fragments'

export const CREATE_POST = gql`
  mutation createPost($input: PostCreateInput) {
    squareModule {
      status: createPost(PostCreateInput: $input)
    }
  }
`

export const UPDATE_POST = gql`
  mutation updatePost($input: PostUpdateInput) {
    squareModule {
      status: updatePost(postUpdateInput: $input)
    }
  }
`

export const GET_POST = gql`
  ${POST_ITEM_FIELDS}
  ${POST_ITEM_USER}
  query getPost(
    $id: Long!
    $offset: Long
    $turnPageParam: CopyrightAiTextSearchParam
  ) {
    squareModule {
      squarePost: baseSquarePost(id: $id) {
        ...postItemFields
        # 详情上下一个
        turnPageInfo(offset: $offset, param: $turnPageParam) {
          next
          prev
        }
        ... on SquarePost {
          visible
          sameCreated
          updateTime
          top
          canDownSourceImage
          artwork {
            id
          }
          createTags {
            id
            name
            publishVisible
          }
          createLikewiseCast
          supportSameType {
            aiArtworkSameType
            name
            sameModel {
              name
              modelCode
            }
          }
          user {
            ...postItemUser
          }
          #是否被推荐
          recommend
          specialImage {
            image {
              imageUrl
            }
            tagEnum
          }
        }
      }
    }
  }
`
/** 获取帖子详情 */
export const GET_POST_NOTE = gql`
  query getPostNote($id: Long!) {
    squareModule {
      squarePost(id: $id) {
        id
        title
        content
        type
        visibleType
        publishTime
        updateTime
        commentCount
        sameCount
        postScope
        top
        createTags {
          id
          name
          publishVisible
        }
        coverImage {
          id
          imageUrl
          width: length
          height: width
        }
        imageList {
          id
          imageUrl
        }
        itemSocialInfo {
          collectsCount
          likesCount
          status {
            collected
            liked
          }
        }

        user {
          uid
          nickname
          avatarUrl
          social {
            followStatus
          }
          memberDetail {
            hold
          }
        }

        # 关联作品
        postRelatonSource {
          relationPost {
            title
            coverImage {
              imageUrl
            }
            sameCount
            id
          }
        }
        # 段落
        squareNoteContent {
          noteParagraph {
            content
            noteImage {
              imageUrl
              sourceType
              aiArtwork {
                extend {
                  squarePost {
                    title
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const DELETE_POST = gql`
  mutation deletePost($id: Long) {
    squareModule {
      status: deletePost(id: $id)
    }
  }
`
/** 置顶 */
export const TOP_POST = gql`
  mutation topPost($id: Long, $actionType: ActionType) {
    squareModule {
      status: topPost(id: $id, actionType: $actionType)
    }
  }
`

export const LIKE_POST = gql`
  mutation likePost($input: GeneralSocialActionInput!) {
    squareModule {
      status: doLikeAction(param: $input)
    }
  }
`
/** 踩一踩 */
export const DIS_LIKE_POST = gql`
  mutation disLikePost($input: GeneralSocialActionInput!) {
    squareModule {
      status: putDownAction(param: $input)
    }
  }
`
export const FAV_POST = gql`
  mutation favPost($input: GeneralSocialActionInput!) {
    squareModule {
      status: doCollectAction(param: $input)
    }
  }
`

export const GET_PLAZA_OTPIONS = gql`
  query getPlazaOptions($param: SquareOptionQueryInput) {
    squareModule {
      squareOptionMenu(param: $param) {
        createTagOptions {
          id
          name
          publishVisible
          promptSize
          useful
        }
      }
    }
  }
`

const COMMENT_FIELD = gql`
  fragment commentField on CommentInfo {
    canDel
    commentId
    content
    publishTime
    likesCount
    liked
    replyCount
    rootCommentId
    userInfo {
      uid
      base {
        nickname
        avatarUrl
        memberDetail {
          hold
        }
      }
    }
    parentCommentInfo {
      commentId
      userInfo {
        uid
        base {
          nickname
          avatarUrl
        }
      }
    }
  }
`

export const GET_COMMENT_LIST = gql`
  ${COMMENT_FIELD}
  query getCommentList(
    $first: Int
    $offset: Int
    $input: QueryCommentListInput
  ) {
    copyrightCommentModule {
      commentList(page: { first: $first, offset: $offset }, param: $input) {
        pageInfo {
          totalCount
          hasNextPage
        }
        edges {
          node {
            ...commentField
            replies {
              ...commentField
            }
          }
        }
      }
    }
  }
`

export const DELETE_COMMENT = gql`
  mutation deleteComment($id: Long) {
    status: deleteComment(commentId: $id)
  }
`

export const PUBLISH_COMMENT = gql`
  ${COMMENT_FIELD}
  mutation publishComment($input: PublishCommentInput) {
    publishComment(param: $input) {
      ...commentField
      replies {
        ...commentField
      }
    }
  }
`

export const COMMENT_EXIST = gql`
  query commentExist($id: Long) {
    copyrightCommentModule {
      status: commentExist(commentId: $id)
    }
  }
`

/** 一键同款（包括图生图）*/
export const AI_ARTWORK_POST_SAME = gql`
  mutation aiArtworkPostSame($param: AiArtworkPostSameInput) {
    squareModule {
      aiArtworkId: aiArtworkPostSame(param: $param)
    }
  }
`

// 投诉 -- 提交投诉内容
export const COMPLAIN_COMFIRM = gql`
  mutation squarePostComplaint($param: SquarePostComplaintInput!) {
    squareModule {
      succeed: squarePostComplaint(input: $param)
    }
  }
`
// 投诉 -- 获取投诉类型
export const COMPLAIN_TYPE_LIST = gql`
  query getComplainTypeList {
    squareModule {
      complaintTypeList
    }
  }
`
// 投诉 -- 获取投诉原因
export const COMPLAIN_REASONS = gql`
  query getComplainReasons {
    squareModule {
      complaintTemplateList
    }
  }
`

// 投诉 -- 获取当前用户是否能够投诉
export const COMPLAIN_CAN_COMPLAINT = gql`
  query canComplaint($postId: Long!) {
    squareModule {
      canComplaint(postId: $postId)
    }
  }
`
export const AI_UPDATE_POST = gql`
  mutation aiUpdatePost($input: UpdateToSimilarPostInput!) {
    squareModule {
      status: updateToSimilarPost(param: $input)
    }
  }
`

/**我发布的广场 */
export const USER_SQUAREPOST_LIST = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query userPostPage(
    $offset: Int
    $first: Int
    $param: PostUserQueryInput
    $isNote: Boolean = false
  ) {
    squareModule {
      userPostPage(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              type
              top
              visible
              squareNoteContent @include(if: $isNote) {
                noteParagraph {
                  content
                  noteImage {
                    id
                    imageUrl
                  }
                }
                postId
              }
              user {
                ...postItemUser
              }
              status
              specialImage {
                image {
                  imageUrl
                }
                tagEnum
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`

/** 广场标签 */
export const GET_TAGS = gql`
  query getTags($param: SquareOptionQueryInput) {
    squareModule {
      squareOptionMenu(param: $param) {
        createTagOptions {
          id
          name
          icon
        }
      }
    }
  }
`

/** 广场关注｜发现 */
export const GET_POST_LIST = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query getPostList($offset: Int, $first: Int, $param: PostQueryInput) {
    squareModule {
      postPage(page: { first: $first, offset: $offset }, param: $param) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              user {
                ...postItemUser
              }
              type
              status
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
        }
      }
    }
  }
`

export const DOWNLOAD_IMAGE = gql`
  mutation downloadImage($param: PostImageDownloadInput) {
    squareModule {
      url: downloadImage(param: $param)
    }
  }
`

export const TRANSLATE_PROMPT = gql`
  query translatePrompt(
    $aiArtworkId: Long
    $aiArtworkSource: AiArtworkSource
    $promptEnum: AiArtworkPromptEnum
  ) {
    aiArtworkResourceModule {
      result: aiArtworkPromptTranslation(
        aiArtworkId: $aiArtworkId
        aiArtworkSource: $aiArtworkSource
        promptEnum: $promptEnum
      )
    }
  }
`

/** 广场 -- ai创作页(包含合集) */
export const GET_SQUARE_AI_REGION_PAGE = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query getSquareAiRegionPage(
    $endCursor: String
    $first: Int
    $param: PostQueryInput
  ) {
    squareModule {
      squareAiRegionPage(
        page: { first: $first, after: $endCursor, pattern: CURSOR }
        param: $param
      ) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              user {
                ...postItemUser
              }
              type
              competitionStyle
              aiCollection {
                aiArtworkCount
                coverAiArtworks {
                  id
                  miniArtWorkUrl
                }
              }
              #是否被推荐
              recommend
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
          endCursor
        }
      }
    }
  }
`
/** 广场 -- 关注 */
export const GET_SQUARE_FOCUS_REGION_PAGE = gql`
  query getSquareFocusRegionPage(
    $endCursor: String
    $first: Int
    $param: FocusQueryInput
  ) {
    squareModule {
      squareFocusRegionPage(
        page: { first: $first, after: $endCursor, pattern: CURSOR }
        param: $param
      ) {
        edges {
          node {
            post {
              type
              user {
                uid
                nickname
                avatarUrl
                social {
                  followStatus
                }
                userRoleInfo {
                  artist
                  aiArtist
                }
              }
              status
              id
              title
              content
              sameCount
              postScope
              publishTime
              visibleType
              coverImage {
                id
                imageUrl
                width: length
                height: width
              }
              imageList {
                id
                imageUrl
              }
              itemSocialInfo {
                collectsCount
                likesCount
                status {
                  collected
                  liked
                }
              }
              competitionStyle
              aiCollection {
                aiArtworkCount
                coverAiArtworks {
                  id
                  miniArtWorkUrl
                }
              }
              aiArtworkInfo {
                id
                prompt
                superType
                chatGptOptimize
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          totalCount
          endCursor
        }
      }
    }
  }
`
/** 获取合集详情 */
export const GET_POST_COLLECTION = gql`
  query getPostCollection(
    $id: Long!
    $offset: Int
    $first: Int
    $param: AiArtworkQueryInput
  ) {
    squareModule {
      squarePost(id: $id) {
        id
        title
        content
        type
        publishTime
        updateTime
        commentCount
        top
        postScope
        createTags {
          id
          name
          publishVisible
        }
        aiCollection {
          id
          collectionName
          owned
          visible
          top
          coverAiArtworks {
            miniArtWorkUrl
          }
          aiArtworks(page: { offset: $offset, first: $first }, param: $param) {
            edges {
              cursor
              node {
                miniArtWorkUrl
                id
                width: length
                height: width
                size
                # 模型主题
                model
                modelTheme
                # 修饰风格
                style
                styleDecorationOptions {
                  name
                }
                styleModelOption {
                  key
                  name
                }
                # 提示词相关性
                seed
                # 角色同人
                character
                characterOptions {
                  name
                }
                # 融合模型
                modelFusionOptions: modelFusion {
                  name
                  weight
                }
                # 参考图
                initImageUrl
                multiReferenceImageUrlList
                cfg
                extend {
                  squarePostLink
                  squarePost {
                    visible
                    title
                    id
                    sameCount
                    postScope
                    createLikewiseCast
                    commentCount
                    # supportSameType {
                    #   aiArtworkSameType
                    #   name
                    #   sameModel {
                    #     name
                    #     modelCode
                    #   }
                    # }
                    imageList {
                      id
                      imageUrl
                    }
                    coverImage {
                      id
                      imageUrl
                    }
                    itemSocialInfo {
                      collectsCount
                      likesCount
                      status {
                        collected
                        liked
                      }
                    }
                    visibleType
                    artwork {
                      id
                    }
                    aiArtworkInfo {
                      hiddenBaseInfo
                      superType
                      model
                    }
                    #是否被推荐
                    recommend
                  }
                }
              }
            }
            pageInfo {
              hasNextPage
              totalCount
            }
          }
        }
        itemSocialInfo {
          collectsCount
          likesCount
          status {
            collected
            liked
          }
        }

        user {
          uid
          nickname
          avatarUrl
          muzzleStatus
          social {
            followStatus
          }
          memberDetail {
            hold
          }
        }
      }
    }
  }
`

export const CREATE_SHARE_CODE = gql`
  mutation createShareCode(
    $aiArtworkId: Long!
    $source: AiArtworkShareSource = AI_ARTWORK
  ) {
    pictureMutation {
      code: createAiArtworkSharingCode(
        aiArtworkId: $aiArtworkId
        source: $source
      )
    }
  }
`

export const GET_SHAREINFO = gql`
  query getShareInfo($code: String!) {
    pictureGraph {
      aiArtworkSharingInfo(sharingCode: $code) {
        sharingFrom {
          base {
            inviteCode
          }
        }
        sharingAiArtwork {
          miniArtWorkUrl
          prompt
          modelTheme
          maskImageUrl
          maskZoneImageUrl
          riskControl {
            status
          }
          styleDecorationOptions {
            key
            name
            type
            category
          }
          styleModelOption {
            key
            name
          }
          characterOptions {
            key
            name
            type
            category
          }
          modelFusionOptions: modelFusion {
            key
            name
            weight
          }
          userTrainedModelOption {
            weight
            trainedModel {
              id
              modelName
              valid
            }
          }
          model
          size
          initImageUrl
          multiReferenceImageUrlList
          artist
          style
          length
          width
          specificSize
          creativityDegree
          modelCode
          resolutionKey
          pattern
          ucPrompt
          # doRepairTheHand
          createSource # 创建来源 0-正常绘画 1-一键照改漫
          # 预处理方式
          pretreatmentMethod
          # 预处理图
          pretreatmentImage {
            url
          }
          samplerModelInfo {
            samplerIndex
          }
          doRepairTheHand
          superType
          prefineInfo {
            strength
            multiple
          }
          cfg
          ensd
          clipSkip
          mjParam {
            chaos
            quality
            stylize
            tile
            upbeta
            srefUrls
            sw
            crefUrls
            cw
          }
          anyTextMode
          eta
          strength
          pattern
          layerDiffusion {
            endingStep
            weight
          }
          generateTime
          modelDefaultParam {
            cfg
            clipSkip
            ensd
            modelCode
            modelParamChangeTime
            samplerIndex
          }
          instantStyle {
            imageUrl
            controlWeight
            showType
            pulidMode
          }
          cutDiffusion {
            cfgScale1
            cfgScale2
            cutdiffProportion
          }
          flux {
            chaos
            style
          }
        }
      }
    }
  }
`

export const AI_COLLECTION_USER = gql`
  query aiCollectionUser($id: Long!) {
    aiCollectionQuery {
      details(param: { id: $id }) {
        id
        owned
      }
    }
  }
`

/** 合集详情 -- 私有 */
export const AI_COLLECTION_DETAIL_PRIVATE = gql`
  query aiCollectionDetailPrivate(
    $id: Long!
    $offset: Int
    $first: Int
    $param: AiArtworkQueryInput
  ) {
    aiCollectionQuery {
      details(param: { id: $id }) {
        id
        collectionName
        collectionContent
        aiArtworkCount
        visible
        owned
        top
        coverAiArtworks {
          miniArtWorkUrl
        }
        squarePublished
        squarePost {
          id
          title
          type
          commentCount
          postScope
          itemSocialInfo {
            collectsCount
            likesCount
            status {
              collected
              liked
            }
          }
          user {
            uid
            nickname
            avatarUrl
            social {
              followStatus
            }
          }
        }
        aiArtworks(page: { offset: $offset, first: $first }, param: $param) {
          edges {
            cursor
            node {
              id
              artWorkUrl
              miniArtWorkUrl
              status
              serviceStatus
              violationRefundStatus # 违规退还状态
              involveYellow
              completePercent
              queuePercent
              width: length
              height: width
              size
              # 模型主题
              model
              modelTheme
              # 修饰风格
              style
              styleDecorationOptions {
                name
              }
              styleModelOption {
                key
                name
              }
              # 提示词相关性
              seed
              # 角色同人
              character
              characterOptions {
                name
              }
              # 融合模型
              modelFusionOptions: modelFusion {
                name
                weight
              }
              # 参考图
              initImageUrl
              multiReferenceImageUrlList
              cfg
              riskControl {
                status
              }
              extend {
                # 是否上架到市场 已上架
                artworkLink
                # 是否参加大赛 已投稿
                competitionLink
                # 是否发布到广场 已发布
                squarePostLink
                # 作品对应的广场帖子
                squarePost {
                  title
                  id
                  sameCount
                  postScope
                  createLikewiseCast
                  commentCount
                  # supportSameType {
                  #   aiArtworkSameType
                  #   name
                  #   sameModel {
                  #     name
                  #     modelCode
                  #   }
                  # }
                  # imageList {
                  #   id
                  #   imageUrl
                  # }
                  itemSocialInfo {
                    collectsCount
                    likesCount
                    status {
                      collected
                      liked
                    }
                  }
                  visibleType
                  artwork {
                    id
                  }
                  aiArtworkInfo {
                    hiddenBaseInfo
                  }
                }
              }
            }
          }
          pageInfo {
            totalCount
            hasNextPage
          }
        }
      }
    }
  }
`
export const AI_COLLECTION_DETAIL_PRIVATE_SIMPLE = gql`
  query aiCollectionDetailPrivateSimple(
    $id: Long!
    $endCursor: String
    $first: Int
    $startCursor: String
    $last: Int
    $param: AiArtworkQueryInput
  ) {
    aiCollectionQuery {
      details(param: { id: $id }) {
        id
        aiArtworks(
          page: {
            first: $first
            after: $endCursor
            last: $last
            before: $startCursor
            pattern: CURSOR
          }
          param: $param
        ) {
          edges {
            cursor
            node {
              id
              miniArtWorkUrl
              extend {
                # 作品对应的广场帖子
                squarePost {
                  id
                }
              }
            }
          }
          pageInfo {
            totalCount
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
        }
      }
    }
  }
`
/** 查询是否为白名单用户 */
export const USER_WHITE_LIST_AUTH = gql`
  query userWhiteListAuth($writeListType: WhitelistType) {
    status: whitelistQuery(writeListType: $writeListType)
  }
`

/** 推荐帖子 */
export const RECOMMEND_POST = gql`
  mutation recommnedPost($actionType: ActionType, $id: Long) {
    squareModule {
      success: recommendPost(id: $id, actionType: $actionType)
    }
  }
`

/** 禁言操作：取消或者禁言 */
export const CHECK_MUTE = gql`
  mutation checkMute($param: BackendMuzzleOpInput!) {
    success: userMuzzle(param: $param)
  }
`

/** 后台白名单：删除帖子  */
export const DELETE_SQUARE_POST = gql`
  mutation deleteSquarePost($id: Long, $remark: String) {
    squareModule {
      success: backendDeletePost(id: $id, remark: $remark)
    }
  }
`

/** 后台白名单：隐藏帖子  */
export const HIDE_SQUARE_POST = gql`
  mutation hideSquarePost($postId: Long) {
    squareModule {
      success: hidePost(postId: $postId)
    }
  }
`

/** 后台白名单：隐藏合集 */
export const HIDE_COLLECTION = gql`
  mutation hideCollection($id: Long) {
    squareModule {
      success: checkPost(
        id: $id
        remark: "前台白名单用户隐藏合集"
        status: REFUSE
      )
    }
  }
`
